<template>
    <c-modal :value="isOpen" title="Add a custom map style" size="lg" @closed="handleCancel">
        <div>
            <p>
                Paste your public Style URL below to add it to your options.
                <a href="https://docs.mapbox.com/help/glossary/style-url/" target="_blank" rel="noopener noreferrer"
                    >More info</a
                >.
            </p>
            <c-input v-model="inputValue" label="Custom Mapbox Style" placeholder="mapbox://styles/username/style_id" />
        </div>
        <template #modal-footer>
            <div class="d-flex">
                <c-button text="Cancel" variant="secondary" @click="handleCancel" />
                <c-button text="Save" :disabled="!inputValue" variant="primary" @click="handleSave" />
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import CModal from '@/components/CModal.vue';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton';

const MAP_BOX_PREFIX = 'mapbox://styles/';

interface Emits {
    (event: 'input', value: boolean): void;
    (event: 'save', data: { id: number; value: string }): void;
}

const props = withDefaults(
    defineProps<{
        value: boolean;
        styleId?: string;
        editIndex?: number;
    }>(),
    {
        styleId: ''
    }
);
const emit = defineEmits<Emits>();

const inputValue = ref('');

const isOpen = ref(props.value);

watch(
    () => props.value,
    (val) => {
        isOpen.value = val;
        if (val && props.styleId) {
            inputValue.value = `${MAP_BOX_PREFIX}${props.styleId}`;
        }
    }
);

const handleCancel = () => {
    inputValue.value = '';
    emit('input', false);
};

const handleSave = () => {
    if (props.editIndex == null) return;

    emit('save', {
        id: props.editIndex,
        value: inputValue.value.replace(MAP_BOX_PREFIX, '')
    });
    emit('input', false);
};
</script>
